import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RefferalSummaryService {

  constructor(private _http : HttpClient) { }

  getReferralSummaryData(searchCriteria : any) : Observable<any>{
    return this._http.post<any>(environment.config.BASE_API_URL + 'ReferralFriend/PostReferralFriendReport', searchCriteria);
  }
}
